import styled, { css } from 'styled-components';
import { xsMd } from '../../theme/utils/media-query';
import { spacing_1_5, spacing_2 } from '../../theme/spacing';
import { primaryForSite, secondaryForSite, gray_6 } from '../../theme/colors'
import { h3_bold, body, h4_bold } from '../../theme/type-styles';
import { spacing_0_5, spacing_0_75, spacing_1 } from '../../theme/spacing';
import { border_radius_1 } from '../../theme/border'

export function makeArticle (element) {
  return styled(element)`
    width: 100%;
    margin-top: 0;
    a {
      display: flex;
      justify-content: space-around;
      color: ${ gray_6 };
    }

    .articleInfo {
      text-align: left;
      h3 {
        ${h3_bold};
        margin-bottom: ${ spacing_0_5 };
      }
      p {
        ${body};
        margin-bottom: ${ spacing_1 };
      }
      .readMore {
        ${h4_bold};
        display: flex;
        align-items: center;
        justify-content: flex-start;
        color: #04857e;
        transition: color 0.1s, fill 0.1s;

        svg {
          margin-left: ${ spacing_0_75};
        }

        &:hover {
          color: ${props => secondaryForSite('careguide.com')};
          transition: color 0.1s;
          path {
            fill: ${props => secondaryForSite('careguide.com')};
            transition: fill 0.1s;
          }
        }
      }
    }
    .articleImage {
      max-width: 250px;
      max-height: 160px;
      border-radius: ${ border_radius_1 };
      margin-bottom: ${ spacing_2 };
      margin-right: ${ spacing_1_5 };
    }

    &:last-child {
      .articleImage {
        margin-bottom: 0;
      }
    }

    ${xsMd(css`
      {
        margin-bottom: ${ spacing_2 };
        a {
          max-width: 284px;
          margin: 0 auto;
        }
        &:last-child {
          margin-bottom: 0;
          .articleImage {
            margin-bottom: ${ spacing_2 };
          }
        }
        a {
          flex-wrap: wrap;
          justify-content: flex-start;
        }
        .articleImage {
          max-width: 100%;
          width: 100%;
          margin-bottom: ${ spacing_2 };
          margin-right: 0;
        }
        .articleInfo {
          max-width: 100%;
        }
      }
    `)}
  `
}

export default makeArticle